module.exports = __webpack_public_path__ + "img/nav_application_xyxy.dd5169c4.png";